import { render } from "./Dashboard.vue?vue&type=template&id=82704d4a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=82704d4a&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82704d4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82704d4a', __exports__)) {
    console.log('reload')
    api.reload('82704d4a', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=82704d4a", () => {
    console.log('re-render')
    api.rerender('82704d4a', render)
  })

}


export default __exports__